import { businessDayOfMonth } from "@/helpers/time";
import type { Dayjs } from "dayjs";
import { REPORT_DEADLINE_DAY } from "../claims/reporting";
import { ENROLLMENT_CUTOFF_DAY } from "../contracts/enrollment";
import { ProtectNavigation } from "../types";

const DESIST_DEADLINE_DAY = 19;

export type Deadline = {
  id: string;
  day: number;
  title: string;
  bannerTitle: string;
  description: string;
  caption: string;
  action: string;
  params: ProtectNavigation;
};

export type DatedDeadline = Deadline & { date: Dayjs };

export const DEADLINES: Deadline[] = [
  {
    id: "dia_max_avisos",
    day: REPORT_DEADLINE_DAY,
    title: "Reportar incumplimientos",
    bannerTitle: "reportar incumplimientos",
    description: "Último día para reportar que un inquilino no pagó.",
    caption: "Reporta a quien no pagó",
    action: "Revisar",
    params: { tab: "reclamaciones", claimsTab: "porReclamar" },
  },
  {
    id: "corte_ingresos",
    day: ENROLLMENT_CUTOFF_DAY,
    title: "Ingresos y novedades",
    bannerTitle: "registrar ingresos y novedades",
    description:
      "Último día para ingresar contratos nuevos, aumentos y retiros del mes.",
    caption: "Contratos y aumentos",
    action: "Ver pendientes",
    params: { tab: "contratos" },
  },
  {
    id: "dia_desistimientos",
    day: DESIST_DEADLINE_DAY,
    title: "Límite para desistir",
    bannerTitle: "desistir de una reclamación",
    description: "Último día para retirar una reclamación que ya reportaste.",
    caption: "Retira una reclamación",
    action: "Ver mis reclamaciones",
    params: { tab: "reclamaciones", claimsTab: "reclamados" },
  },
];

type PalommaPayment = {
  id: string;
  description: string;
  caption: string;
};

export const PALOMMA_PAYMENTS: PalommaPayment[] = [
  {
    id: "pago_siniestro_vigente",
    description: "Pago de obligaciones vigentes",
    caption: "Las que siguen vigentes",
  },
  {
    id: "pago_siniestro_nuevo",
    description: "Pago de obligaciones aprobadas este mes",
    caption: "Las aprobadas este mes",
  },
];

export const deadlineRule = (day: number): string =>
  `El ${day} de cada mes, o el siguiente día hábil si cae en fin de semana o festivo.`;

export const PALOMMA_PAYMENT_RULE =
  "El día hábil siguiente al límite para desistir.";

export const datedDeadlines = (month: Dayjs): DatedDeadline[] =>
  DEADLINES.map((deadline) => ({
    ...deadline,
    date: businessDayOfMonth(month, deadline.day),
  }));

export const palommaPaymentDate = (month: Dayjs): Dayjs =>
  businessDayOfMonth(month, DESIST_DEADLINE_DAY).nextBusinessDay();
